export default "__VITE_ASSET__82d66ad9__"